import React, { FC } from 'react';
import { Skeleton } from 'antd';
import styles from './styles.module.css';

export const DrawerSkeleton: FC = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.detailsHeader}>
      <Skeleton
        active
        title={{ width: '60%' }}
        paragraph={{ rows: 2, width: ['100%', '80%'] }}
      />
    </div>
    <div className={styles.detailsBody}>
      <Skeleton.Image active className={styles.skeletonScreenshot} />
      <Skeleton
        active
        title={false}
        paragraph={{ rows: 5 }}
        className={styles.skeletonFields}
      />
    </div>
  </div>
);
